var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "call_native_wrapper" }, [
    _c(
      "div",
      {
        staticClass: "call_native_float_button",
        attrs: { id: "wx_open_app_float_button" },
      },
      [
        _c(
          "WXLaunchBtn",
          {
            attrs: { schema: _vm.schema },
            on: {
              error: _vm.handleWxLunchBtnError,
              wxClick: _vm.handleWxClick,
            },
          },
          [
            _c("template", { slot: "default" }, [
              _c(
                "div",
                {
                  staticClass: "icon_text",
                  attrs: { id: "openBtn" },
                  on: { click: _vm.callNativeAmap },
                },
                [_vm._v("高德地图APP内打开")]
              ),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }